namespace GeniuzPOS.ReportMasterData {
    export interface Report_1101Form {
        PluDesc: Serenity.StringEditor;
        SkuCode: Serenity.StringEditor;
        SupplierId: Serenity.StringEditor;
        SupplName: Serenity.StringEditor;
        CatCode: Serenity.LookupEditor;
        CatName: Serenity.StringEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        StyleId: Serenity.StringEditor;
        StyleName: Serenity.StringEditor;
        ColorId: Serenity.StringEditor;
        ColorName: Serenity.StringEditor;
        SizeId: Serenity.StringEditor;
        SizeName: Serenity.StringEditor;
        TasteId: Serenity.StringEditor;
        TasteName: Serenity.StringEditor;
        MatTypeId: Serenity.StringEditor;
        MatTypeName: Serenity.StringEditor;
        PurUnit: Serenity.StringEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        PurUnitRatio: Serenity.StringEditor;
        StkUnit: Serenity.StringEditor;
        SellUnitRatio: Serenity.DecimalEditor;
        SellUnit: Serenity.StringEditor;
        MinStockQty: Serenity.DecimalEditor;
        MaxStockQty: Serenity.DecimalEditor;
        SellUnitPrice1: Serenity.DecimalEditor;
        SellUnitPrice2: Serenity.DecimalEditor;
        SellUnitPrice3: Serenity.DecimalEditor;
        SellUnitPrice4: Serenity.DecimalEditor;
        SellUnitPrice5: Serenity.DecimalEditor;
        SellUnitPrice6: Serenity.DecimalEditor;
        VatType: Serenity.StringEditor;
        VatCode: Serenity.StringEditor;
    }

    export class Report_1101Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1101';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1101Form.init)  {
                Report_1101Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(Report_1101Form, [
                    'PluDesc', w0,
                    'SkuCode', w0,
                    'SupplierId', w0,
                    'SupplName', w0,
                    'CatCode', w1,
                    'CatName', w0,
                    'SubCat1Code', w1,
                    'SubCat2Code', w1,
                    'BrandCode', w1,
                    'StyleId', w0,
                    'StyleName', w0,
                    'ColorId', w0,
                    'ColorName', w0,
                    'SizeId', w0,
                    'SizeName', w0,
                    'TasteId', w0,
                    'TasteName', w0,
                    'MatTypeId', w0,
                    'MatTypeName', w0,
                    'PurUnit', w0,
                    'PurUnitPrice', w2,
                    'PurUnitRatio', w0,
                    'StkUnit', w0,
                    'SellUnitRatio', w2,
                    'SellUnit', w0,
                    'MinStockQty', w2,
                    'MaxStockQty', w2,
                    'SellUnitPrice1', w2,
                    'SellUnitPrice2', w2,
                    'SellUnitPrice3', w2,
                    'SellUnitPrice4', w2,
                    'SellUnitPrice5', w2,
                    'SellUnitPrice6', w2,
                    'VatType', w0,
                    'VatCode', w0
                ]);
            }
        }
    }
}
